import { useIntl } from "react-intl";
import { CompanyRateCodeIcon } from "@/public/icons/CompanyRateCodeIcon";
import { CrossIcon } from "@/public/icons/CrossIcon";
import { useFetchCompanyRate } from "../../../hooks/useFetchCompanyRate";
import styles from "./ActiveCompanyRateCode.module.scss";

export type ActiveCompanyRateCodeProps = {
  code: string;
  updateCompanyRateCode: (code: string | undefined) => void;
};
export const ActiveCompanyRateCode = ({
  code,
  updateCompanyRateCode,
}: ActiveCompanyRateCodeProps) => {
  const intl = useIntl();

  const { companyRate } = useFetchCompanyRate(code);

  const handleOnCrossIconClick = () => {
    updateCompanyRateCode(undefined);
  };

  return (
    <>
      {companyRate && (
        <div className={styles.activeCompanyRateCodeContainer}>
          <CompanyRateCodeIcon color={"#37837d"} />
          <div>
            {intl.formatMessage(
              {
                id: "companyRateCodeApplied",
              },
              {
                companyName: companyRate.companyName,
              }
            )}
          </div>
          <div
            className={styles.crossContainer}
            onClick={handleOnCrossIconClick}
          >
            <CrossIcon color={"#37837d"} size={18}></CrossIcon>
          </div>
        </div>
      )}
    </>
  );
};
